import Constant from '@/constant'
import presentation from './presentation'

const getSlideActive = (state) => {
  return state.slideActive
}

const getSlideOptionsActive = (state) => {
  return state.slideActive.SlideOptions
}

const getSelectedSlides = (state) => {
  const selected = state.selections.selectedSlideIds.length
    ? state.selections.selectedSlideIds
    : [state.slideActive.id]

  return state.presentation.slides
    .filter((slide) => selected.some((id) => id === slide.id))
    .sort((a, b) => a.order - b.order)
}

const selectedFolder = (state) => {
  return state.folders.find((folder) => folder.folderId === state.selections.selectedFolderId)
}

export default {
  ...presentation,
  getSlideActive,
  getSlideOptionsActive,
  selectedFolder,
  currentSlideIndex: (state) => {
    return state.presentation && state.presentation.slides && state.presentation.slides.findIndex(
      (s) => s.id === state.slideActive.id,
    )
  },
  selectedSlides: (state) => {
    return getSelectedSlides(state)
  },
  selectedSlide: (state) => {
    return getSelectedSlides(state)
      .reduce((a, b) => {
        const c = {}
        Constant.commonSlideAttributes.forEach((prop) => {
          if (a[prop] === undefined) {
            c[prop] = b[prop]
          } else if (prop === 'backgroundImage' || prop === 'audioLink') {
            c[prop] = (a[prop] && a[prop].name) === (b[prop] && b[prop].name) ? b[prop] : null
          } else if (prop === 'backgroundImageCropperData') {
            c[prop] = a[prop] || b[prop]
          } else if (prop === 'visibility') {
            c[prop] = parseInt(a[prop], 10) === parseInt(b[prop], 10) ? parseInt(b[prop], 10) : 20
          } else {
            c[prop] = a[prop] === b[prop] ? b[prop] : null
          }
        })
        return c
      }, {})
  },

  abTestGroup: (state) => {
    return state.currentUser && state.currentUser.id % 4
  },
}
